import { render, staticRenderFns } from "./Obrigado.vue?vue&type=template&id=377b6453&scoped=true&"
import script from "./Obrigado.vue?vue&type=script&lang=js&"
export * from "./Obrigado.vue?vue&type=script&lang=js&"
import style0 from "./Obrigado.vue?vue&type=style&index=0&id=377b6453&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377b6453",
  null
  
)

export default component.exports